import { render } from "./CatalogView.vue?vue&type=template&id=536d0cbc"
import script from "./CatalogView.vue?vue&type=script&lang=js"
export * from "./CatalogView.vue?vue&type=script&lang=js"

import "./CatalogView.vue?vue&type=style&index=0&id=536d0cbc&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__